// extracted by mini-css-extract-plugin
module.exports = {"main":"TableCells_main__1LDXq","list":"TableCells_list__Baqjh","firstItemBold":"TableCells_firstItemBold__8TtNe","link":"TableCells_link__3I5-i"};